import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, ButtonGroup } from 'components/misc'

export default class FilterActions extends Component {
  static propTypes = {
    query: PropTypes.string,
    setFilter: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
  }

  handleSetFilter = () => {
    this.props.reset()
    this.props.setFilter()
  }

  render() {
    const { query } = this.props

    return (
      <ButtonGroup >
        <Button
          intlKey="button.filter"
          primary
        >
          Filter
        </Button>
        {query && (
          <Button
            intlKey="button.clear"
            secondary
            onClick={this.handleSetFilter}
          >
            Clear
          </Button>
        )}
      </ButtonGroup>
    )
  }
}
